import { getDepotCountries } from '../../data/localExport';

/**
 * 28/07/2026 — Le recrutement local exige désormais un dépôt physique dans
 * le pays du chauffeur. Au rehydrate, les chauffeurs locaux dont le pays
 * n'a pas (ou plus) de dépôt quittent l'effectif (choix user 2b). Les
 * chauffeurs en mission active sont épargnés jusqu'au prochain reload.
 * Retourne { drivers, vehicles, removed } ou null si rien à faire.
 */
export function pruneLocalDriversWithoutDepot(state) {
  const drivers = state.drivers || [];
  if (!drivers.some(d => d && d.localCountry)) return null;
  const countries = getDepotCountries(state);
  const vehicles = state.vehicles || [];
  const isOnMission = (d) => {
    if (!d.assignedVehicleId) return false;
    const v = vehicles.find(x => x.id === d.assignedVehicleId);
    return !!v && v.status === 'active';
  };
  const removed = drivers.filter(
    d => d && d.localCountry && !countries.has(d.localCountry) && !isOnMission(d),
  );
  if (removed.length === 0) return null;
  const removedIds = new Set(removed.map(d => d.id));
  return {
    drivers: drivers.filter(d => !removedIds.has(d.id)),
    vehicles: vehicles.map(v =>
      removedIds.has(v.assignedDriverId) ? { ...v, assignedDriverId: null, status: 'idle' } : v,
    ),
    removed,
  };
}
